import { Tabs } from '@cian/ui-kit';
import * as React from 'react';

import { TransportAccessibilitySidebar } from 'shared/components/TransportAccessibility';
import { ETransportAccessibilityTab, TTAInfrastructureType } from 'shared/types/map';

import { useTransportAccessibilityTabs } from './hooks';
import { TransportAccessibilityInside } from '../TransportAccessibilityInside';
import { TransportAccessibilityOutside } from '../TransportAccessibilityOutside';

export interface ITransportAccessibilitySidebarContainerProps {
  onClose: () => void;
  onTransportAccessibilityChange: (infrastructureType: TTAInfrastructureType | null) => void;
}

export const TransportAccessibilitySidebarContainer: React.FC<ITransportAccessibilitySidebarContainerProps> = ({
  onClose,
  onTransportAccessibilityChange,
}) => {
  const tabs = useTransportAccessibilityTabs();
  const [activeTab, setActiveTab] = React.useState<string>(tabs[0].value);

  const hasVisibileTabs = tabs.length > 1;

  return (
    <TransportAccessibilitySidebar
      onClose={onClose}
      tabs={hasVisibileTabs && <Tabs activeTab={activeTab} onChange={setActiveTab} tabs={tabs} />}
    >
      {activeTab === ETransportAccessibilityTab.Outside && (
        <TransportAccessibilityOutside onTransportAccessibilityChange={onTransportAccessibilityChange} />
      )}
      {activeTab === ETransportAccessibilityTab.Inside && (
        <TransportAccessibilityInside onTransportAccessibilityChange={onTransportAccessibilityChange} />
      )}
    </TransportAccessibilitySidebar>
  );
};
